import { useRef } from "react";
import { cx } from "class-variance-authority";
import { CSSTransition } from "react-transition-group";
import Ic12 from "~/images/deliberation/KR/KRMedia/12.png";
import Ic15 from "~/images/deliberation/KR/KRMedia/15.png";
import Ic19 from "~/images/deliberation/KR/KRMedia/19.png";
import IcAll from "~/images/deliberation/KR/KRMedia/all.png";
import IcCopying from "~/images/deliberation/KR/KRMedia/copying.png";
import IcDrug from "~/images/deliberation/KR/KRMedia/drug.png";
import IcFear from "~/images/deliberation/KR/KRMedia/fear.png";
import IcScript from "~/images/deliberation/KR/KRMedia/script.png";
import IcSexuality from "~/images/deliberation/KR/KRMedia/sexuality.png";
import IcSubject from "~/images/deliberation/KR/KRMedia/subject.png";
import IcViolence from "~/images/deliberation/KR/KRMedia/violence.png";
import type { Deliberation, DeliberationLevelType } from "~/payloads";
import { typography } from "~/styles/typographies";
import styles from "./Deliberation.module.css";

interface DeliberationProps {
  visible: boolean;
  deliberation: Deliberation;
}

export function Deliberation({ visible, deliberation }: DeliberationProps) {
  const nodeRef = useRef(null);
  const { levels, deliberationCode, ratingCode, subtitleText } = deliberation;

  function getAgeIcon() {
    switch (ratingCode) {
      case "all":
        return IcAll;
      case "12":
        return Ic12;
      case "15":
        return Ic15;
      case "19":
        return Ic19;
      default:
        return undefined;
    }
  }

  function getLevelIcon(type: DeliberationLevelType) {
    switch (type) {
      case "copying":
        return IcCopying;
      case "drug":
        return IcDrug;
      case "fear":
        return IcFear;
      case "script":
        return IcScript;
      case "sexuality":
        return IcSexuality;
      case "subject":
        return IcSubject;
      case "violence":
        return IcViolence;
      default:
        return undefined;
    }
  }

  return (
    <CSSTransition
      classNames="deliberation"
      in={visible}
      nodeRef={nodeRef}
      timeout={300}
    >
      <div
        ref={nodeRef}
        className={cx(
          typography({ fontSize: "body4", fontWeight: "regular" }),
          styles.deliberation,
          visible && styles.visible,
        )}
      >
        <div className={styles.levels}>
          <img
            key={deliberationCode}
            alt={deliberationCode}
            src={getAgeIcon()}
          />
          {levels
            ? Object.keys(levels).map(level => (
                <img
                  key={level}
                  alt={level}
                  src={getLevelIcon(level as DeliberationLevelType)}
                />
              ))
            : null}
        </div>
        <p>{deliberationCode}</p>
        <p>{subtitleText}</p>
      </div>
    </CSSTransition>
  );
}
